import { useTranslation } from "react-i18next";
import type { ModelVersionChecks } from "../../../api/content/ontologyApi";
import type { LoadState } from "../../../shared/loading/useLoad";
import { chipClassName } from "../../../ui/styles/chipStyles";
import { versionCheckSummary } from "./versionCheckSummary";

/**
 * The status of the version the Data model page shows (FR-MODEL-4, design pass section 9):
 * one chip after the version, "Checks: all pass", "2 fail", "not run" or "1 not checked", with the model's
 * and the process graph's checks alike. It opens the side panel with the results. The page
 * explains nothing else about checks: the hint does.
 */
export default function VersionChecksChip({
  state,
  open,
  onToggle,
}: {
  state: LoadState<ModelVersionChecks>;
  open: boolean;
  onToggle: () => void;
}) {
  const { t } = useTranslation();
  const summary = state.status === "loaded" ? versionCheckSummary(state.value) : null;
  const label =
    summary === null
      ? t(state.status === "failed" ? "ontologyViewer.checks.chip.failed" : "ontologyViewer.checks.chip.running")
      : t(`ontologyViewer.checks.chip.${summary.key}`, { count: summary.count });
  return (
    <button
      type="button"
      className={chipClassName(summary?.tone ?? (state.status === "failed" ? "warning" : "neutral"))}
      aria-expanded={open}
      title={t("ontologyViewer.checks.chip.hint")}
      onClick={onToggle}
    >
      {label}
    </button>
  );
}
